/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  /**
   * Cart recommendations carousel ("Recommended for you")
   *
   * Fills snippets/cart-recommended-products.liquid with products and (re)starts the carousel.
   *
   * Complementary products cannot be read from Liquid — the reserved
   * shopify--discovery--product_recommendation namespace is only reachable through the Product
   * Recommendations API. So we fetch sections/cart-recommendations here:
   *   1. intent=complementary — curated add-ons, needs setup in the Search & Discovery app
   *   2. intent=related       — auto-generated by Shopify, so this always returns something
   * A server-rendered fallback collection, when configured, is left alone unless the API has
   * something better to show.
   */
  var BLOCK = '[data-cart-recs]';
  var CONTENT = '[data-cart-recs-content]';
  var SLIDER = '[data-pair-products]';
  var CELL = '[data-upsell-holder]';

  // De slider loopt van rand tot rand; de kaarten springen in via de
  // snap-offset. Zo blijft de vorige kaart links zichtbaar in plaats van te
  // worden afgekapt door een padding. De afstand komt uit --cart-peek, zodat
  // mobiel (16px) en desktop (24px) in de CSS geregeld blijven.
  var PEEK_FALLBACK = 24;

  function peekFor(slider) {
    var value = parseInt(
      getComputedStyle(slider).getPropertyValue('--cart-peek'),
      10,
    );
    return isNaN(value) ? PEEK_FALLBACK : value;
  }

  /**
   * cellAlign blijft 'left', zodat een kaart op zijn linkerrand uitlijnt.
   * Alleen de cursor schuift op: Flickity zet die in getSize() op 0, hier op
   * PEEK px. Elke resize rekent hem opnieuw uit, vandaar ook het resize-event.
   */
  function setPeekOffset(flkty) {
    if (!flkty || !flkty.size || !flkty.size.innerWidth) return;

    flkty.cursorPosition = peekFor(flkty.element);
    flkty.positionSliderAtSelected();
  }

  /**
   * De slider wordt opgebouwd terwijl de lade nog verborgen is en meet dan
   * breedte 0, waardoor de offset niet gezet kan worden. Bij de eerste keer dat
   * hij echt breedte krijgt opnieuw meten. Alleen op een gewijzigde breedte,
   * zodat de hoogteaanpassing van de slider geen lus veroorzaakt.
   */
  function watchWidth(slider, flkty) {
    if (typeof ResizeObserver === 'undefined') return;

    var lastWidth = slider.clientWidth;
    new ResizeObserver(function () {
      if (slider.clientWidth === lastWidth) return;
      lastWidth = slider.clientWidth;
      flkty.resize();
    }).observe(slider);
  }

  /**
   * Koppelt de vorige/volgende-knoppen in de kop aan de carousel. Flickity's
   * eigen knoppen worden niet gebruikt: zo staat het chevron-icoon van het
   * theme in de kop, op de plek van de vroegere paginabolletjes.
   */
  function bindNav(block, flkty) {
    var nav = block.querySelector('[data-cart-recs-nav]');
    if (!nav || nav.dataset.navBound) return;
    nav.dataset.navBound = 'true';
    nav.hidden = false;

    nav.querySelector('[data-cart-recs-prev]').addEventListener('click', function () {
      flkty.previous();
    });

    nav.querySelector('[data-cart-recs-next]').addEventListener('click', function () {
      flkty.next();
    });
  }

  /**
   * Bewaakt de snap-offset en de navigatie. Flickity zet cursorPosition bij elke
   * hermeting terug op 0 en wordt opgebouwd terwijl de lade nog verborgen is,
   * dus dit loopt mee met elke scan: idempotent en zelfherstellend.
   */
  function ensureSliders() {
    var Flickity =
      (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
    if (!Flickity) return;

    document.querySelectorAll(SLIDER).forEach(function (slider) {
      var flkty = Flickity.data(slider);
      if (!flkty || !flkty.size || !flkty.size.innerWidth) return;

      var peek = peekFor(slider);
      if (flkty.cursorPosition !== peek) {
        flkty.cursorPosition = peek;
        flkty.positionSliderAtSelected();
      }

      var block = slider.closest(BLOCK);
      if (block) bindNav(block, flkty);
    });
  }

  function startSlider(block) {
    // Flickity is bundled in vendor.js as themeVendor.Flickity, not on window
    var Flickity = (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
    if (!Flickity) return;

    var slider = block.querySelector(SLIDER);
    if (!slider) return;

    if (slider.classList.contains('flickity-enabled')) {
      var existing = Flickity.data(slider);
      if (existing) {
        existing.reloadCells();
        existing.resize();
        setPeekOffset(existing);
      }
      return;
    }

    if (slider.querySelectorAll(CELL).length < 2) return;

    // Options mirror CartDrawer.renderPairProducts() in theme.dev.js so both paths look identical
    var flkty = new Flickity(slider, {
      wrapAround: true,
      // Navigatie zit in de kop (bindNav), niet als bolletjes of eigen knoppen
      pageDots: false,
      adaptiveHeight: true,
      prevNextButtons: false,
      // Kaarten links uitlijnen zodat de eerste op 24px staat en de volgende
      // er half naast piept, zoals in Figma 1754-10985
      cellAlign: 'left',
      // Eén kaart per stap. Zonder dit bundelt Flickity alle kaarten die samen
      // in beeld passen tot één slide, waardoor een brede lade in één keer
      // voorbij de hele groep springt en de vorige kaart volledig verdwijnt.
      groupCells: 1,
      on: {
        ready: function () {
          this.reloadCells();
          requestAnimationFrame(this.resize.bind(this));
        },
      },
    });

    // Buiten de ready-handler om: die wordt niet altijd afgemaakt
    requestAnimationFrame(function () {
      setPeekOffset(flkty);
    });

    // getSize() rekent cursorPosition bij elke resize opnieuw uit de opgeslagen
    // fractie; die klopt alleen voor de oude breedte, dus opnieuw zetten
    flkty.on('resize', function () {
      setPeekOffset(flkty);
    });

    watchWidth(slider, flkty);
  }

  function fetchIntent(baseUrl, intent) {
    return fetch(baseUrl + '&intent=' + intent)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        if (!text) return '';
        var parsed = document.createElement('div');
        parsed.innerHTML = text;
        var content = parsed.querySelector(CONTENT);
        return content && content.innerHTML.trim().length ? content.innerHTML : '';
      })
      .catch(function () {
        return '';
      });
  }

  // The holder is server-rendered with `hidden` and normally only unhidden by
  // CartDrawer.toggleClassesOnContainers() after a cart mutation. On the first
  // open of an already-filled cart that never runs, so reveal it here as soon
  // as there are cards to show.
  function reveal(block) {
    var holder = block.closest('[data-pair-products-holder]');
    if (holder && block.querySelectorAll(CELL).length > 0) {
      holder.classList.remove('hidden');
    }

    // Prefer the theme's own CartDrawer re-init: renderPairProducts() starts the
    // same Flickity carousel ánd bindt de quick-view popup op de plusknoppen van
    // producten met meerdere varianten. startSlider is de fallback voor de cart
    // page, waar window.cart niet bestaat.
    if (window.cart && typeof window.cart.renderPairProducts === 'function') {
      window.cart.renderPairProducts();
    } else {
      startSlider(block);
    }

    requestAnimationFrame(ensureSliders);
  }

  function load(block) {
    if (block.dataset.cartRecsLoaded) return;
    block.dataset.cartRecsLoaded = 'true';

    var baseUrl = block.dataset.recommendationsUrl;

    if (!baseUrl) {
      reveal(block);
      return;
    }

    // Show the server-rendered fallback right away rather than waiting on the network
    if (block.hasAttribute('data-has-fallback')) reveal(block);

    fetchIntent(baseUrl, 'complementary')
      .then(function (markup) {
        return markup || fetchIntent(baseUrl, 'related');
      })
      .then(function (markup) {
        if (markup) block.innerHTML = markup;
        reveal(block);
      });
  }

  /**
   * De positie-indicator van de productgalerij is een overlay op de dots-rij
   * (zie .flickity-page-dots::after in custom.css). Die schuift op --dot-index,
   * dus met een transform: de enige eigenschap die iOS Safari volledig op de
   * compositor afhandelt en die dus niet hapert tijdens een swipe.
   */
  function bindGalleryDots() {
    var Flickity =
      (window.themeVendor && window.themeVendor.Flickity) || window.Flickity;
    if (!Flickity) return;

    document
      .querySelectorAll('.product-single__media-slider')
      .forEach(function (gallery) {
        var flkty = Flickity.data(gallery);
        if (!flkty) return;

        var sync = function () {
          var dots = gallery.querySelector('.flickity-page-dots');
          if (dots) dots.style.setProperty('--dot-index', flkty.selectedIndex);
        };

        // De vlag staat op de instantie: het theme kan de slider opnieuw
        // opbouwen, en dan hoort er opnieuw gebonden te worden.
        if (!flkty._dotIndexBound) {
          flkty._dotIndexBound = true;
          flkty.on('select', sync);
        }

        sync();
      });
  }

  function scan() {
    document.querySelectorAll(BLOCK).forEach(load);
    ensureSliders();
    bindGalleryDots();
  }

  // Coalesce bursts of mutations into one scan per tick. setTimeout instead of
  // requestAnimationFrame: rAF never fires in a hidden/background tab, which
  // would leave scanQueued permanently true and block every later scan.
  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(function () {
      scanQueued = false;
      scan();
    }, 0);
  }

  // The cart drawer is rendered from a <template> on first open and replaced on every cart
  // update, so watch for the block appearing rather than binding once on load.
  new MutationObserver(queueScan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /**
   * Cart line item edit toggle
   *
   * Het potlood opent de wijzig-stand van een cart-regel (variant-selects +
   * vinkje), het vinkje sluit hem weer. De selects zelf wisselen de variant
   * direct bij een keuze (cartVariantChangeEvent in theme.dev.js); na zo'n
   * update rendert de drawer opnieuw in de dichte stand. Gedelegeerd op
   * document omdat de drawer bij elke cart-update opnieuw wordt opgebouwd.
   */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-item-edit-toggle]');
    if (!toggle) return;

    event.preventDefault();

    var item = toggle.closest('[data-cart-item]');
    if (item) item.classList.toggle('is-editing');
  });

  /**
   * Afrekenen terwijl een variantwijziging nog wordt opgeslagen
   *
   * De mousedown hierboven start het opslaan; de klik erna zou het formulier
   * versturen met de cart van vóór die wijziging. In plaats van de knop te
   * blokkeren onthouden we de bedoeling: de klik wordt tegengehouden en zodra
   * de cart is bijgewerkt gaat hij alsnog door naar de checkout.
   */
  var CHECKOUT = '[name="checkout"]';

  function cartIsBusy() {
    return Boolean(
      document.querySelector('[data-cart-item][data-variant-pending]') ||
        document.querySelector('[data-cart-item].is-loading'),
    );
  }

  var checkoutQueued = false;

  function checkoutWhenSaved() {
    if (checkoutQueued) return;
    checkoutQueued = true;

    var tries = 0;

    (function attempt() {
      // De lade wordt opnieuw opgebouwd, dus de knop van zojuist bestaat niet
      // meer; wachten tot de nieuwe er is én weer klikbaar is
      var button = document.querySelector(CHECKOUT);

      if (!cartIsBusy() && button && !button.hasAttribute('disabled')) {
        checkoutQueued = false;
        button.click();
        return;
      }

      if (++tries > 100) {
        checkoutQueued = false;
        return;
      }

      setTimeout(attempt, 100);
    })();
  }

  // CartDrawer schakelt tijdens het opslaan alle knoppen uit, en een
  // uitgeschakelde knop vuurt geen click. De bedoeling leggen we daarom al op
  // mousedown vast; anders zou die eerste klik verloren gaan. Op iOS begint
  // dat nog eerder: touchstart commit de wijziging en schakelt de knop uit
  // voordat er überhaupt een mouse-event komt, dus daar luisteren we ook.
  var captureCheckoutIntent = function (event) {
    if (!event.target.closest(CHECKOUT)) return;
    if (!cartIsBusy()) return;

    // De handlers die de wijziging opslaan draaien op ditzelfde event:
    // pas daarna staat vast of er echt iets wordt bijgewerkt
    setTimeout(function () {
      if (cartIsBusy()) checkoutWhenSaved();
    }, 0);
  };

  document.addEventListener('mousedown', captureCheckoutIntent);
  document.addEventListener('touchstart', captureCheckoutIntent, {
    passive: true,
  });

  // Toetsenbord (Enter) stuurt alleen een click; zolang de knop nog aan staat
  // vangen we die hier op
  document.addEventListener('click', function (event) {
    var button = event.target.closest(CHECKOUT);
    if (!button || !cartIsBusy()) return;

    event.preventDefault();

    document
      .querySelectorAll('[data-cart-item][data-variant-pending]')
      .forEach(function (item) {
        if (window.cart && typeof window.cart.commitVariantChange === 'function') {
          window.cart.commitVariantChange(item);
        }
      });

    checkoutWhenSaved();
  });

  // Buiten de velden klikken sluit de wijzig-stand. Is er wel iets gekozen, dan
  // slaat CartDrawer dat op dezelfde mousedown op en rendert de regel opnieuw.
  document.addEventListener('mousedown', function (event) {
    var open = document.querySelectorAll('[data-cart-item].is-editing');
    if (!open.length) return;

    Array.prototype.forEach.call(open, function (item) {
      var editArea = item.querySelector('[data-item-edit-area]');
      if (editArea && editArea.contains(event.target)) return;
      item.classList.remove('is-editing');
    });
  });

  /**
   * Aantal-kaarten: de buitenring (badge-strip "MEEST GEKOZEN", rand en
   * waszak-rij) valt buiten het label en deed niets bij een klik. Het label
   * zelf is position: relative, dus een CSS-overlay kan het klikvlak niet
   * oprekken; daarom selecteert deze delegate de optie bij elke klik binnen
   * de kaart. Kliks op het label/de input doen het al zelf.
   */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.radio__buttons--aantal .radio__button');
    if (!button) return;
    if (event.target.closest('label, input, a, button, select')) return;

    var input = button.querySelector('.radio__input');
    if (input && !input.checked) input.click();
  });

  // Preorder widget
  document.addEventListener('theme:variant:change', function (event) {
    const container = event.target;
    const variant = event.detail.variant;
    if (!variant) return;

    const dataScript = container.querySelector('[id^="PreorderData-"]');
    if (!dataScript) return;

    const data = JSON.parse(dataScript.textContent);
    const info = data[variant.id];
    const widget = container.querySelector('[data-preorder-widget]');
    const badge = container.querySelector('[data-preorder-badge]');
    const shipping = container.querySelector('[data-preorder-shipping]');
    const buyButtonText = container.querySelector('[data-add-to-cart-text]');

    if (info && info.preorder) {
      widget?.classList.remove('hidden');

      if (info.extra) {
        badge.textContent = `${info.extra}% pre-order korting`;
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }

      if (shipping) {
        shipping.textContent = `Verzending: ${info.datum}`;
      }

      if (buyButtonText) {
        buyButtonText.textContent = theme.strings.preorder;
      }
    } else {
      widget?.classList.add('hidden');
    }
  });

    /**
   * Geen paginascroll naar de variant afbeelding op desktop.
   * Palo Alto scrollt bij een variantwissel naar de bijbehorende foto in de
   * grid. Direct na een keuze in het productformulier negeren we die scroll.
   */
  (function () {
    var DESKTOP = window.matchMedia('(min-width: 768px)');
    var LOCK_MS = 1500;
    var lockUntil = 0;

    function locked() {
      return DESKTOP.matches && Date.now() < lockUntil;
    }

    document.addEventListener(
      'change',
      function (event) {
        if (
          event.target.closest(
            'form[action*="/cart/add"], .product-single, [data-section-type="product"]',
          )
        ) {
          lockUntil = Date.now() + LOCK_MS;
        }
      },
      true,
    );

    var originalScrollTo = window.scrollTo;
    var originalScrollBy = window.scrollBy;
    var originalIntoView = Element.prototype.scrollIntoView;

    window.scrollTo = function () {
      if (locked()) return;
      return originalScrollTo.apply(window, arguments);
    };

    window.scrollBy = function () {
      if (locked()) return;
      return originalScrollBy.apply(window, arguments);
    };

    Element.prototype.scrollIntoView = function () {
      if (locked() && this.closest('.product-single, [data-section-type="product"]')) return;
      return originalIntoView.apply(this, arguments);
    };
  })();

  /**
   * Cadeau-stappen in de cart
   *
   * Zet de cadeautjes uit Theme settings > Cart > Gift steps in de cart zodra
   * de drempel gehaald is, en haalt ze weg als de cart eronder zakt. Welke stap
   * gehaald is staat alleen in snippets/cart-gift-steps: dit script leest die
   * uitkomst (bij het laden uit de pagina, daarna via de Section Rendering API)
   * en rekent zelf niets uit, zodat de balk en de cart nooit uit elkaar lopen.
   *
   * Gratis maakt een automatische Buy X get Y korting in Shopify. Kost een
   * cadeauregel toch geld, dan haalt het script hem weg en probeert het die
   * stap pas opnieuw als de cart verder oploopt dan het bedrag waarop het
   * misging. Zo betaalt niemand voor een cadeau, en loopt het niet rond.
   */
  (function () {
    var SECTION = 'cart-gift-steps';
    var STATE = '[data-gift-steps-state]';
    var BAR = '[data-gift-steps]';
    var FAILED_KEY = 'solit:gift-steps-failed';
    var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var nativeFetch = window.fetch.bind(window);

    function readState(scope) {
      var element = scope.querySelector(STATE);
      if (!element) return null;

      try {
        return JSON.parse(element.textContent);
      } catch (error) {
        return null;
      }
    }

    var initial = readState(document);

    // Uit en geen cadeauregels meer in de cart: niets te doen, ook niet later
    if (!initial || (!initial.enabled && !initial.lines.length)) return;

    function readFailed() {
      try {
        return JSON.parse(sessionStorage.getItem(FAILED_KEY)) || {};
      } catch (error) {
        return {};
      }
    }

    function writeFailed(failed) {
      try {
        sessionStorage.setItem(FAILED_KEY, JSON.stringify(failed));
      } catch (error) {
        // Privémodus: de prijscheck voorkomt nog steeds dat iemand betaalt
      }
    }

    function post(path, body) {
      return nativeFetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      }).then(function (response) {
        return response.ok ? response.json() : null;
      });
    }

    function fetchState() {
      return nativeFetch(root + '?sections=' + SECTION)
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (sections) {
          if (!sections || !sections[SECTION]) return null;

          var doc = new DOMParser().parseFromString(sections[SECTION], 'text/html');
          return { state: readState(doc), bar: doc.querySelector(BAR) };
        });
    }

    /**
     * De drawer staat tot de eerste keer openen in een <template>; die wordt
     * ook bijgewerkt, anders toont een vers geopende drawer de oude stand. De
     * vulling schuift vanaf de vorige breedte, zoals bij de oude balk.
     */
    function renderBar(fresh) {
      if (!fresh) return;

      var targets = Array.prototype.slice.call(document.querySelectorAll(BAR));
      document.querySelectorAll('template').forEach(function (template) {
        targets = targets.concat(Array.prototype.slice.call(template.content.querySelectorAll(BAR)));
      });

      targets.forEach(function (target) {
        var previous = target.querySelector('[data-gift-steps-bar]');
        var from = previous && previous.style.getPropertyValue('--gift-steps-progress');

        target.innerHTML = fresh.innerHTML;

        var bar = target.querySelector('[data-gift-steps-bar]');
        if (!from || !bar || !target.isConnected) return;

        var to = bar.style.getPropertyValue('--gift-steps-progress');
        bar.style.setProperty('--gift-steps-progress', from);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bar.style.setProperty('--gift-steps-progress', to);
          });
        });
      });
    }

    /**
     * Vergelijkt de gehaalde stappen met de cadeauregels in de cart. Geeft de
     * regels om weg te halen of terug te zetten op 1 stuk, en de cadeautjes om
     * toe te voegen.
     */
    function plan(state) {
      var failed = readFailed();
      var updates = {};
      var additions = [];
      var claimed = {};

      state.lines.forEach(function (line) {
        var step = state.enabled
          ? state.steps.filter(function (item) {
              return item.step === line.step;
            })[0]
          : null;

        if (!step || !step.reached || step.variantId !== line.variantId || claimed[line.step]) {
          updates[line.key] = 0;
          return;
        }

        if (line.price > 0) {
          updates[line.key] = 0;
          failed[line.step] = state.qualifyingTotal;
          console.warn(
            '[gift-steps] Het cadeau van stap ' + line.step + ' was niet gratis en is weggehaald. Check de automatische korting in Shopify.',
          );
          return;
        }

        claimed[line.step] = true;
        if (line.quantity > 1) updates[line.key] = 1;
      });

      if (state.enabled) {
        state.steps.forEach(function (step) {
          if (!step.reached || claimed[step.step]) return;
          if (step.step in failed && state.qualifyingTotal <= failed[step.step]) return;

          additions.push({
            id: step.variantId,
            quantity: 1,
            properties: { _gift_step: String(step.step) },
          });
        });
      }

      writeFailed(failed);
      return { updates: updates, additions: additions };
    }

    function apply(actions, state) {
      var changed = false;
      var chain = Promise.resolve();

      if (Object.keys(actions.updates).length) {
        chain = chain.then(function () {
          return post('cart/update.js', { updates: actions.updates }).then(function (cart) {
            if (cart) changed = true;
          });
        });
      }

      if (actions.additions.length) {
        chain = chain.then(function () {
          return post('cart/add.js', { items: actions.additions }).then(function (result) {
            if (result) {
              changed = true;
              return;
            }

            // Bijvoorbeeld uitverkocht: niet blijven proberen bij dit bedrag
            var failed = readFailed();
            actions.additions.forEach(function (item) {
              failed[item.properties._gift_step] = state.qualifyingTotal;
            });
            writeFailed(failed);
          });
        });
      }

      return chain.then(function () {
        return changed;
      });
    }

    function refreshCart() {
      // De cart-pagina rendert niet opnieuw, de drawer haalt zijn regels zelf op
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
      } else if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    }

    var syncing = false;
    var syncAgain = false;

    function sync(knownState) {
      if (syncing) {
        syncAgain = true;
        return;
      }

      syncing = true;
      var mutated = false;
      var current = knownState ? Promise.resolve({ state: knownState, bar: null }) : fetchState();

      current
        .then(function (result) {
          if (!result || !result.state) return;
          renderBar(result.bar);

          return apply(plan(result.state), result.state).then(function (changed) {
            if (!changed) return;
            mutated = true;

            // Tweede ronde: is een net toegevoegd cadeau ook echt gratis?
            return fetchState().then(function (after) {
              if (!after || !after.state) return;
              renderBar(after.bar);
              return apply(plan(after.state), after.state);
            });
          });
        })
        .catch(function (error) {
          console.warn('[gift-steps] De cadeautjes konden niet worden bijgewerkt.', error);
        })
        .then(function () {
          syncing = false;
          if (mutated) refreshCart();

          if (syncAgain) {
            syncAgain = false;
            sync();
          }
        });
    }

    /**
     * Elke cart-wijziging volgen, ook die van apps (EG Auto Add, Easy Bundle):
     * de theme heeft geen event dat ze allemaal dekt. Eigen requests gaan via
     * nativeFetch en tellen dus niet mee.
     */
    function isCartMutation(method, url) {
      return String(method).toUpperCase() === 'POST' && CART_MUTATION.test(String(url));
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var request = nativeFetch(input, init);

      if (isCartMutation(method, url)) {
        request.then(
          function (response) {
            if (response.ok) sync();
          },
          function () {},
        );
      }

      return request;
    };

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.giftStepsWatch = isCartMutation(method, url);
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.giftStepsWatch) {
        this.addEventListener('load', function () {
          if (this.status < 400) sync();
        });
      }
      return nativeSend.apply(this, arguments);
    };

    sync(initial);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
